<template>
  <a-card size="small">
    <template #title>待选列表 - {{ value.length }}项</template>
    <template #extra>
      <a-button size="small" type="link" @click="remove">删除选中</a-button>
    </template>
    <!-- <a-table
      row-key="storageId"
      size="small"
      :bordered="true"
      :data-source="value"
      :columns="columns"
      :scroll="{ x: true, y: tableHeight + 'px' }"
      :pagination="false"
      :row-selection="{
        selectedRowKeys: selectedIds,
        onChange: onSelectionChange,
        fixed: true,
      }"
      @change="onTableChange"
    >
    </a-table> -->
    <table-wrapper
      row-key="storageId"
      size="small"
      :border="true"
      ref="tableRef"
      :data-source="value"
      :columns="columns"
      @onSelectionChange="onSelectionChange"
      :pagination="false"
      :tableHeight="tHeight"
      @onTableChange="onTableChange"
    ></table-wrapper>
  </a-card>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, reactive, toRefs, watch } from "vue";
import { columns } from "./constant";
import { StoreMaterialListRecord } from "../store-material-interface";

export default defineComponent({
  name: "SelectedTable",
  props: {
    value: {
      type: Array as PropType<StoreMaterialListRecord[]>,
      default: [],
    },
    tableHeight: {
      type: Number,
      default: 0,
    },
  },
  emits: ["update:value"],
  setup(props, { emit }) {
    const state = reactive<{
      current: number;
      selectedIds: string[];
      columns: any[];
    }>({
      current: 1,
      selectedIds: [],
      columns,
    });

    const tHeight = computed(() => props.tableHeight + 31);

    const onSelectionChange = (ids: string[]) => {
      state.selectedIds = ids;
    };

    const onTableChange = async (pagination) => {
      state.current = pagination.current;
    };

    const remove = () => {
      const newValue = (props.value || []).filter((item) => {
        if (state.selectedIds.length > 0) {
          return !state.selectedIds.includes(item.storageId);
        } else {
          //@ts-ignore
          return !item?.checkedTableRow;
        }
      });
      emit("update:value", newValue);
    };
    return {
      ...toRefs(state),
      onSelectionChange,
      onTableChange,
      remove,
      tHeight,
    };
  },
});
</script>
